/* @flow */

import type { JSON } from 'common/types';
import { withDefault, array, items } from 'common/json/extract';

export default function resources<V>(resource: JSON => V): JSON => Array<V> {
  return withDefault(array(items(resource)), []);
}
